import { emitter } from '@/utils/emitter'

export default {
  install (app, options) {
    app.config.globalProperties.$hub = emitter
  }
}
